const Events = {

    // Contact button clicked
    CONTACT_BTN_CLICKED: 'contact_btn_clicked',

    // User clicked on Eigen X logo, navigating them to the Eigen X analytics home page
    NAVIGATE_EXTERNAL_EIGENX_HOME: 'navigate_external_eigenx_home',

    // User clicked on a navigation item
    NAVIGATION_ITEM_CLICKED: 'navigation_item_clicked',

    // Tableau viz actions
    TABLEAU_REFRESH_BTN_CLICKED: 'tableau_refresh_btn_clicked',
    TABLEAU_FS_BTN_CLICKED: 'tableau_fs_btn_clicked',
    TABLEAU_EXPORT_IMAGE_BTN_CLICKED: 'tableau_export_image_btn_clicked',
    TABLEAU_EXPORT_PDF_BTN_CLICKED: 'tableau_export_pdf_btn_clicked',
    TABLEAU_EXPORT_EXCEL_BTN_CLICKED: 'tableau_export_excel_btn_clicked',
    TABLEAU_COPY_LINK_BTN_CLICKED: 'tableau_copy_link_btn_clicked',

    // Navigation - dashboard item clicked by user
    NAVIGATION_DASHBOARD_CLICKED: 'kpi_dashboard_item_clicked',

    // Contact page - user clicked on a contact method (email, phone, link)
    CONTACT_METHOD_CLICKED: 'contact_method_clicked',

    // Home page - user clicked on an external link
    HOME_EXTERNAL_LINK_CLICKED: 'home_external_link_clicked',

    // Carousel - user clicked on a dashboard
    CAROUSEL_DASHBOARD_CLICKED: 'carousel_dashboard_clicked',

    SETTINGS_OPTION_CLICKED: 'settings_option_clicked'
}

export default Events;